export default "/bundles/assets/photo9_c532754f94de9d5daa1decd8ddb9badd.png";